import "./Experience.css";

import EntryRoom from "./EntryRoom/EntryRoom.jsx";
import { Canvas } from "@react-three/fiber";
import UiManager from "./UiManager";
import RoomPush from "./EntryRoom/RoomPush";
import { useState, useRef, useEffect, lazy, Suspense } from "react";
import { Environment, useGLTF } from "@react-three/drei"
import { useSnapshot } from "valtio";
import { AdaptiveDpr, AdaptiveEvents } from "@react-three/drei";
import { Perf } from "r3f-perf";
import ThemeWallnoCollison from "./EntryRoom/ThemeWall/ThemeWallnoCollison";
import InfoStation from "./EntryRoom/InfoStation";
import { PlayerPositionProvider } from "./Utils/PlayerPositionContext";
import ThemeMonitor from "./EntryRoom/ThemeMonitor";
import { getGPUTier } from 'detect-gpu';
import { CacheBuster } from "react-cache-buster/dist/CacheBuster";
import packageFile from "../package.json"
import CameraWaypointControl from "./Utils/CameraWaypointControl.jsx";
import { motion } from "framer-motion";
import { DebugCamTracker } from "./Utils/DebugCamCopy.jsx";
import GpuPrewarm from "./Utils/GpuPrewarm.jsx";




import {

  stateIframeWindow,
  stateDevice,
  stateLoadingScreen,
  stateMemory,
  stateNavigation

} from "./store.jsx";


import {
  PerformanceMonitor,

} from "@react-three/drei";


import CheckLandscapeMode from "./Utils/CheckLandscapeMode";

const PhysicsWorld           = lazy(() => import("./Utils/PhysicsWorld.jsx"));
const CameraControls         = lazy(() => import("./Utils/CameraControls.jsx"));
const CameraControlsCharSwitch = lazy(() => import("./Utils/CameraControslCharSwitch.jsx"));



export default function Experience() {

  const snapIsClickNavigation = useSnapshot(stateNavigation)

  const [gpuTier, setGpuTier] = useState(1);

  const isProduction = process.env.NODE_ENV === 'production';

  const {version} = packageFile
  useEffect(() => {
    const fetchGpuTier = async () => {
      try {
        const tier = await getGPUTier({
          mobileTiers: [0, 15, 40, 60], // Override mobileTiers here
          desktopTiers: [0, 15, 40, 80], // Override mobileTiers here
        });;

        setGpuTier(tier);
      } catch (error) {
        console.error("Error getting GPU tier:", error);
      }
    };

    fetchGpuTier();

    // Cleanup function if needed
    return () => {
      // Cleanup code
    };
  }, []);

  //  let detectedOS

  // useEffect(() => {
  //   // Detect OS and set context power preference
  //   const userAgent = window.navigator.userAgent;
  //   detectedOS = userAgent.match(/Mac/i) ? 'mac' : 'other'; // Simple OS detection
  //   if (detectedOS == 'mac') {
  //     // Set context power preference to "high-performance" for macOS
  //     if (canvasRef.current) {
  //       canvasRef.current.getContext('webgl', { contextPowerPreference : 'high-performance' });
  //     }
  //   }
  // }, []);

  const [gravity, setGravity] = useState(0);
  const snapLaodingscreen = useSnapshot(stateLoadingScreen);
  const snapIframeWindow = useSnapshot(stateIframeWindow);
  const snapNavigation = useSnapshot(stateNavigation)
// const snapStateMemory = useSnapshot(stateMemory)
  const canvasRef = useRef();

  const [aniRunEndDone, setAniRunEndDone] = useState(false);
  const [enableMPerfMon, setEnableMPerfMon] = useState(false);
  // Eigener Flag für den Desktop-Tier-3-High-DPR-Pfad — hängt an einem
  // SEPARATEN PerformanceMonitor, damit der Rescue-Monitor (Tier 0/FALLBACK,
  // deckelt bei 1) unberührt bleibt.
  const [enableHighDpr, setEnableHighDpr] = useState(false);
  const [handy, setHandy] = useState(false);
  const [currentFOV, setcurrentFOV] = useState();

  const iPad =
    navigator.userAgent.match(/(iPad)/) /* iOS pre 13 */ ||
    (navigator.platform === "MacIntel" &&
      navigator.maxTouchPoints > 1); /* iPad OS 13 */

  stateDevice.isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  stateDevice.isTablet = window.innerWidth >= 1000 && window.innerWidth <= 1200;

  const isIPhone = /iPhone|iPod/.test(navigator.userAgent);

  stateDevice.isIphone = isIPhone
  stateDevice.isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  
useEffect(() => {
  const checkPortrait = () => {
    const portrait = window.matchMedia("(orientation: portrait)").matches;
stateDevice.isPortrait = portrait
  };

  checkPortrait();
  window.addEventListener("resize", checkPortrait);

  return () => window.removeEventListener("resize", checkPortrait);
}, []);



useEffect(() => {
  // Compute immediately on mount too, not just on resize — otherwise a page
  // load that starts in landscape (or via devtools device toolbar) never
  // gets a resize event and isHandy stays stuck at its false default.
  const updateHandy = () => setHandy(window.innerWidth <= 1000);
  updateHandy();
  window.addEventListener('resize', updateHandy);
  return () => window.removeEventListener('resize', updateHandy);
}, []);

  if (iPad) {
    stateDevice.isMobile = true;
    stateDevice.isTablet = true;
    stateMemory.scetchfabOff = true
  }
  if (isIPhone) {
    stateDevice.isMobile = true;
    stateMemory.scetchfabOff = true
  }
  stateDevice.isHandy = handy;





  const [light, setLight] = useState(true);

const FOV = stateDevice.isPortrait ? 70 : 60; // wider FOV on portrait

useEffect(() => {

  if(stateDevice.isPortrait){
    setcurrentFOV(70)
  } else{
      setcurrentFOV(60)
    }
 

  }, [stateDevice.isPortrait]); // Empty dependency array for initial mount


  const [dpr, setDpr] = useState(1);



const lowMemoryArray = ["apple a13 gpu"]; 
const lowPerformanceArray = ["apple a13 gpu","apple a15 gpu"];
const tierMeDownArray = ["intel mesa dri intel hd graphics 400"];  






  //setDpr([1.5]); // Set DPR for tier 2
  useEffect(() => {
    // Set DPR based on GPU tier
    if (gpuTier.tier === 1) {
      setDpr([0.5,1]); // Set DPR for tier 1
      stateMemory.memoryLowDevice = true
      stateMemory.performanceLowDevice = true
      stateMemory.scetchfabOff = true
     
      
    } else if (gpuTier.tier === 2 ) {
      stateMemory.performanceLowDevice = true
      if(stateDevice.isMobile){
      stateMemory.memoryLowDevice = true
    }
      setDpr(1); // Set DPR for tier 2
    } else if (gpuTier.tier === 3) {
      // Desktop (nicht mobil, breiter als Handy): Performance vor Qualität.
      // NIEDRIG bei 1 starten (kein 2x-Spike beim Laden) und den High-DPR-
      // Monitor (unten) nur dann HOCHregeln lassen, wenn die echte Framerate
      // es hergibt — bis max 2 für scharfe Retina-Darstellung. Ein schwacher
      // Laptop bleibt so einfach bei 1 statt kurz auf 2 zu ruckeln.
      // Handy/Mobile bleibt bei 1.5.
      if (!stateDevice.isMobile && window.innerWidth > 1000) {
        setDpr(1);
        setEnableHighDpr(true);
      } else {
        setDpr(1.5); // Set DPR for tier 3s
      }
    } else if (gpuTier.tier === 0) {
      setLight(false);
      setDpr(0.5); // Set DPR for tier 3
      // stateMemory.memoryLowDevice = true
      // stateMemory.deviceToOld = true
      stateMemory.performanceLowDevice = true
      stateMemory.scetchfabOff = true
      setEnableMPerfMon(true);
    } 
  
    if (gpuTier.type === "FALLBACK") {
      // setDpr(1)
      setEnableMPerfMon(true);
    }

    
  }, [gpuTier.tier]);


  useEffect(() => {
  
    if (lowMemoryArray.includes(gpuTier.gpu) || isIPhone === true ) {
      stateMemory.memoryLowDevice = true;
      stateMemory.scetchfabOff = true
    }
  }, [gpuTier.gpu]);


  useEffect(() => {
  
    if (lowPerformanceArray.includes(gpuTier.gpu)) {
      stateMemory.performanceLowDevice = true
  
      
    }
    if (tierMeDownArray.includes(gpuTier.gpu)) {
      setDpr([0.5,1])
      stateMemory.performanceLowDevice = true
    }
    if (handy) {
      if(dpr > 1.5){
      setDpr(1.5)
    }
      stateMemory.performanceLowDevice = true
      stateMemory.scetchfabOff = true
  
    }
  }, [gpuTier.gpu]);

useEffect(() => {
  const handleResize = () => {
    const isPortrait = window.innerHeight > window.innerWidth;
    const isHandyWidth = window.innerWidth <= 1000;

    const newSidebarWidth = isPortrait
      ? window.innerWidth
      : isHandyWidth
        // Narrow smartphone in landscape — the 250px desktop floor eats too
        // much of a small screen, so scale down further.
        ? Math.min(280, Math.max(180, window.innerWidth * 0.28))
        : Math.min(450, Math.max(250, window.innerWidth * 0.25));

    stateNavigation.sidebarWidth = newSidebarWidth;
  };

  handleResize();
  window.addEventListener("resize", handleResize);
  return () => window.removeEventListener("resize", handleResize);
}, []);


const sidebarOpen = true
const sidebarWidth = 450
const sidebarHeight = 220
// snapDevice.isPortrait is already being updated in your useEffect
const containerWidth = stateDevice.isPortrait
  ? window.innerWidth        // full width in portrait
  : snapNavigation.slideBarActive
    ? window.innerWidth - sidebarWidth
    : window.innerWidth;

    const canvasHeight = stateDevice.isPortrait
  ? window.innerHeight - sidebarHeight // or any fraction you want
  : window.innerHeight;

useEffect(() => {
  
console.log(snapNavigation.slideBarActive)
  
}, [snapNavigation.slideBarActive]);
  return (
    <CacheBuster
    currentVersion={version}
    isEnabled={isProduction} //If false, the library is disabled.
    isVerboseMode={false} //If true, the library writes verbose logs to console.
    loadingComponent={null} //If not pass, nothing appears at the time of new version check.
    metaFileDirectory={'.'} //If public assets are hosted somewhere other than root on your server.
  >
    <>




     {/* {!snapLaodingscreen.loadingScreenAnimate &&  */}
     <PlayerPositionProvider>
      <div className="relative w-full h-screen flex">
      <motion.div
  animate={{     width: stateDevice.isPortrait
      ? window.innerWidth
      : (snapNavigation.slideBarActive && !snapNavigation.isClickNavi)
        ? window.innerWidth - snapNavigation.sidebarWidth
        : window.innerWidth,
    height: stateDevice.isPortrait
      ? (snapNavigation.isClickNavi ? window.innerHeight : window.innerHeight - snapNavigation.sidebarHeight)
      : window.innerHeight,  }}
  transition={{ duration: 0.3, ease: "easeInOut" }}
  className="h-full"
> <Canvas
          ref={canvasRef}
          frameloop={snapIframeWindow.renderCanvas ? "always" : "never"}
          shadows={false}
          gl={{ antialias: true }}
          dpr={dpr}
          camera={{ fov: currentFOV, position: [0, 20, -180], far: 2000, near: 0.1 }}
          powerpreference="high-performance"
          alpha={false}
          stencil={false}
          depth={false}
          // precision="lowp"
          // performance={{ min: 0.1 }}
        // antialias={false}
      
        >

<Environment 
    // preset = {"city"}
     background = {false}
    intensity={1}
    resolution={256}
    // color="black" // (optional = white)
    files= "./overallTextures/industrial_room.hdr"
  /> 
          {enableMPerfMon && (
            <PerformanceMonitor
              onIncline={() => {
              setDpr(1)
              stateMemory.deviceToOld = false
              }
            }
              onDecline={() =>
              // stateMemory.deviceToOld = true
              setDpr([0.2,1])
              }
              flipflops={4}
            ></PerformanceMonitor>
          )}

          {/* Nur Desktop-Tier-3: startet bei DPR 1 und regelt live anhand der
              echten Framerate HOCH — factor 0 (schlecht) → 1, factor 1 (gut)
              → 2. Performance-first: eine starke Maschine bekommt die volle
              Schärfe, ein schwacher Laptop bleibt bei 1 (nie drunter, nie ein
              2x-Spike beim Laden). */}
          {enableHighDpr && (
            <PerformanceMonitor
              onChange={({ factor }) => setDpr(Math.round((1 + factor) * 10) / 10)}
              flipflops={4}
            ></PerformanceMonitor>
          )}
          {/* {aniRunEndDone && <PerformanceMonitor onChange={({ factor }) => setDpr(round(0.5 + 1.5 * factor, 1))}  ></PerformanceMonitor>} */}


{!snapIsClickNavigation.isClickNavi &&  <CameraWaypointControl></CameraWaypointControl>}
          <DebugCamTracker />
          {snapIsClickNavigation.isClickNavi && (
            <Suspense fallback={null}>
              <CameraControls />
              <CameraControlsCharSwitch />
            </Suspense>
          )}
          {light && (
            <directionalLight
              intensity={0.5}
              position={[30, 40, 60]}
              shadow={false}
            />
          )}

          <ambientLight intensity={0.6} shadow={false} />
          {/* <Preload all /> */}
          {/* Zieht Shader-Kompilierung + GPU-Textur-Uploads auf Momente vor,
              in denen die Kamera still steht — behebt das Erstflug-Ruckeln
              an Schaustellen (lazy Upload beim ersten Frustum-Eintritt). */}
          <GpuPrewarm />

         
        {snapIsClickNavigation.isClickNavi && (
          <Suspense fallback={null}>
            <PhysicsWorld gravity={gravity} />
          </Suspense>
        )}


          <RoomPush></RoomPush>
        
          <ThemeWallnoCollison />
          
         <InfoStation />
      
         <EntryRoom />
         <ThemeMonitor/>
           {/* <Perf 
// overClock= {true}
position ="top-left"></Perf>  */}

         {/* <AdaptiveDpr pixelated/>  */}
             {/* <AdaptiveEvents />   */}
          {/* <AdaptivePixelRatio />  */}
     
     
        </Canvas></motion.div></div> 
        
      </PlayerPositionProvider>
      {/* } */}
    
   

 
  
<UiManager setGravity= {setGravity}></UiManager>
    
  
      {/* <div className="interfaceGPU"><h1>GPU Tier: {gpuTier.tier},{dpr},{gpuTier.type}</h1>
      <div>{gpuTier.gpu}</div>
      <div>{`isTablet: ${stateDevice.isTablet}`}</div>
      <div>{`isHandy: ${handy}`}</div>
      <div>{`memoryLow: ${ stateMemory.memoryLowDevice}`}</div>
    
    </div> */}

    
{/* {  !stateDevice.isMobile  &&  <div className="interfaceGPU">

      <div>{`Updates:`}</div>
      <div>{`CloseButtonOrbit HighlightFix and ClickFix`}</div>
      <div>{`CloseButtons for Orbit and CharSwitch`}</div>
      <div>{`StadlPaura to primär Museum`}</div>
      <div>{`TimeMachines have Orbit UI`}</div>
      <div>{`Bug Fixes when start BrowserWindow is small`}</div>
      <div>{`Graphic Bug Fixes "Salzabbau"Handelswege`}</div>
      <div>{`Homebutton`}</div>
      <div>{`Scaleing Sekundaermuseen`}</div>
      <div>{`fixing wrong poistions Sekundaermuseen`}</div>
      <div>{`panorama change NHM aussenstelle`}</div>
      <div>{`etc.`}</div>
  
    </div>
      } */}
    
     {/* <CheckLandscapeMode></CheckLandscapeMode>  */}
    {/* <Loader></Loader> */}

    </>
    </CacheBuster>
  );
}

// Preload all theme-room floor collider GLBs at startup so they are
// cached before the player mode activates (avoids the Suspense race).
useGLTF.preload("../models/Museum01/Handelswege/HandelswegeCollider.glb");
useGLTF.preload("../models/Museum01/Salzabbau/Salzzeit_Collider.glb");
useGLTF.preload("../models/Museum01/Klima/KlimaCollider.glb");
useGLTF.preload("../models/Museum01/Holzarbeit/Holzarbeit_Collider.glb");
useGLTF.preload("../models/Museum01/MDR/MDR_Collider.glb");
useGLTF.preload("../models/Museum01/Menschen/Menschen_collision.glb");
